export const site = {
  "product": "Sovasta Ads",
  "packageName": "soveads",
  "service": "soveads",
  "domain": "ads.sovetrust.com",
  "sections": [
    "overview",
    "revenue",
    "connectors",
    "ledger",
    "community",
    "pricing",
    "support",
    "account"
  ],
  "labels": {
    "overview": "Overview",
    "revenue": "Revenue",
    "connectors": "Connectors",
    "ledger": "Ledger",
    "community": "Community",
    "pricing": "Pricing",
    "support": "Support",
    "account": "Account"
  },
  "kicker": "PUBLISHER REVENUE OS · TRUSTED MONETIZATION",
  "title": "Route every content asset to its best revenue path.",
  "body": "Sovasta Ads evaluates content, traffic, audience trust, and commercial intent, then recommends the right mix of ads, affiliate, sponsorship, subscription, and data/API revenue.",
  "primary": "Analyze my revenue paths",
  "secondary": "See connector map",
  "proof": "AdSense · Affiliate · Sponsorship · Subscription · API",
  "onboarding": "Add a property, describe traffic, and preview a monetization routing map before sign-in.",
  "demoTitle": "Revenue routing board",
  "demoName": "Publisher Asset Map · +$6,420/mo",
  "demoSignal": "Signal: 5 connectors + verified traffic evidence",
  "lines": [
    "Low-intent posts route to display revenue.",
    "Buying guides route to affiliate and sponsorship offers.",
    "High-trust data pages become subscription or API assets."
  ],
  "workspaceTitle": "Find the money path hidden in your content.",
  "workspaceBody": "Map traffic, intent, and trust evidence. Sovasta Ads turns it into a practical revenue plan and connector checklist.",
  "field1": "Property name",
  "field2": "Audience",
  "field3": "Revenue goal",
  "default1": "AI Workflow Review Hub",
  "default2": "Founders comparing AI tools",
  "default3": "Mix display ads, affiliate offers, and sponsor slots without weakening trust",
  "flowTitle": "Revenue fabric",
  "cards": [
    "Score content intent",
    "Choose connector mix",
    "Estimate upside",
    "Track evidence ledger"
  ],
  "pricing": [
    [
      "Free",
      "$0",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ],
    [
      "Basic",
      "$9/mo",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ],
    [
      "Pro",
      "$29/mo",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ],
    [
      "Premium",
      "$99/mo",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ]
  ],
  "supportPrompt": "Ask how to connect ad networks, pick affiliate offers, price sponsorships, or protect user trust while monetizing."
} as const;
